import React, { Component } from 'react';
import {connect} from 'react-redux';
import  { Redirect } from 'react-router-dom'
import { Button, Form, Icon,Divider,Message, Modal, Label, Dropdown } from 'semantic-ui-react';
import firebase from '../firebase';
import {toast} from 'react-toastify';
import { css } from 'glamor';
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';

/*
    This compoennt is used to log in and sign up. 
*/
class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            password2:'',
            initName:null,
            userName : null,
            id:null, 
            error:'',
            authenticated: true,
            agreedTerms: false,
            showError:false,
            signUp:false,
            signUpName:null
        }
        
        this.handleSignIn = this.handleSignIn.bind(this)
        this.handleSignOut = this.handleSignOut.bind(this)
        this.handleChangeEmail = this.handleChangeEmail.bind(this)
        this.handleChangePassword= this.handleChangePassword.bind(this)
        this.handleChangePassword2= this.handleChangePassword2.bind(this)
        this.handChangeUserName = this.handChangeUserName.bind(this);
        this.handleChangeAgree = this.handleChangeAgree.bind(this)
        this.checkAuthStatus = this.checkAuthStatus.bind(this)
        this.handleSignUp  = this.handleSignUp.bind(this)
        this.sendResetEmail = this.sendResetEmail.bind(this)
        this.handleChangeOrg = this.handleChangeOrg.bind(this);
        this.handleChangeRole = this.handleChangeRole.bind(this);
    }


    handleChangeEmail(event) {
        this.setState({email: event.target.value});
    }

    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }
    handleChangePassword2(event) {
        this.setState({password2: event.target.value});
    }
    handChangeUserName(event){
        this.setState({signUpName:event.target.value});
    }
    handleChangeOrg(e, data){
        e.preventDefault();
        var value = data.value;
        if(value){
            this.setState({org:value})
            this.setState({showSubmit:true}) 
    
        }
        else{
            this.setState({showSubmit:false})
        }
    }

    handleChangeRole(e, data){
        e.preventDefault();
        let value = data.value;;
            if(value){
                this.setState({role:value})
            }
    
    }

    handleChangeAgree(event) {
        this.setState({agreedTerms: !this.state.agreedTerms});
    }

    handleSignIn(e){
        e.preventDefault()

        firebase.fireAuth.signInWithEmailAndPassword(this.state.email, this.state.password)
        .then(
            (ref) => {
                this.setState({userName:ref.displayName, id:ref.uid, showError:false})
                // this.props.stuffActions.fetchStuff();   
                if (this.props.showSuccessAlert){
                    toast("Logged In Successfully!, Welcome "  + this.state.userName);
                }   
                
            }
           
        ).catch(err => {
                this.setState({error: err.message,showError:true})
                toast.warn("Could not authenticate!",{
                    className: css({
                        opacity:"0.7",
                        background: "red",
                        borderRadius: "5px"
                      })
                });
            }
        );

    }
    handleSignOut(e){
        e.preventDefault();
        firebase.fireAuth.signOut().then ( () => {
            //call this function below after every auth fucntion to check and clear auth creds
            // this.checkAuthStatus();  

            toast("Logged Out Successfully!",{
                className: css({
                    opacity:"0.7",
                    background: "teal",
                    color:"black",
                    borderRadius: "5px"
                  })
            });
        });  

    }
    checkAuthStatus(){
    
       this.authListener = firebase.fireAuth.onAuthStateChanged((user) => {
        if (user){
            this.setState({
                initName: user.displayName,
                authenticated: true,
            });
            // this.props.stuffActions.updateAuth(this.state.initName);         
           } else{
            this.setState({
                email: null,
                password: null,
                initName:null,
                userName : null,
                id:null,
                error:null,
                authenticated:null,
                agreedTerms: null,
                showError:null,
                
            })
            // this.props.stuffActions.updateAuth(this.state.displayName);
           } 
       });
    }

    sendResetEmail(e){
        e.preventDefault();
        let email = document.getElementById("resetPasswd").value;
        console.log(email)
        this.props.tokenActions.sendResetEmail(email);
     }

    handleSignUp(e){
        e.preventDefault();
        if(!this.state.signUp){
            this.setState({signUp:true});
        }
       else{ 
        if((this.state.password === this.state.password2)){
            if(this.state.org && this.state.role){

                firebase.fireAuth.createUserWithEmailAndPassword(this.state.email, this.state.password)
                .then((user) =>{
                    this.props.tokenActions.addUser(user.uid, this.state.role, this.state.org, this.state.signUpName, user.email );
                    user.updateProfile({
                        displayName: this.state.signUpName
                    }).then(() =>{
                        this.setState({signUp:false, showError:false, err:null})
                        toast.success("Sign Up Successfull")
                    }).catch((error) => {
                        this.setState({error: error.message,showError:true})
                        toast.warn("Sign Up Error! ",{
                            className: css({
                                opacity:"0.7",
                                background: "red",
                                borderRadius: "5px"
                              })
                        })
                    });
                }
                
                )
                .catch((error) => {
                    this.setState({error: error.message,showError:true})
                    toast.warn("Could not sign up!",{
                        className: css({
                            opacity:"0.7",
                            background: "orange",
                            borderRadius: "5px"
                          })
                    })
                }) 

            } else{
                this.setState({error: "Organisation and/or Access Level Required!",showError:true})
                toast.warn("Form Error!",{
                    className: css({
                        opacity:"0.7",
                        background: "red",
                        borderRadius: "5px"
                      })
                })
            }
 
        }
        else{
            this.setState({error: "Passwords don't match! Please try again.",showError:true})
            toast.warn("Form Error!",{
                className: css({
                    opacity:"0.7",
                    background: "red",
                    borderRadius: "5px"
                  })
            })
        }
    }

    }   
    componentWillReceiveProps(props){
        if(props.emailSuccess === true){
            this.setState({emailSent:true});
            toast("Email Sent Successfully");
        }
        if(props.emailSuccess === false){
            this.setState({emailSent:false});
            toast.error("Error! Make sure you have the correct email address!");
        }
        if(props.addUserSuccess === true){
            toast.success("User Added Successfully!")
          
        }
        if(props.addUserSuccess === false){
            
            toast.error("Error! Could not add user to DB!")
        }
        this.props.tokenActions.hideAlerts();
    }
    componentWillMount(){
        //  this.checkAuthStatus()
        //  console.log(this.props)
    }

    componentDidMount(){    
        this.setState({
            orgs:[{ key: 'arb', value: 'National Arboretum Canberra',text: 'National Arboretum Canberra' },{ key: 'pa', value: 'Public Access',text: 'Public Access'} ],
            roles:[ { key: '' , value: null,text: 'Select Access Level' }, { key: 'dev', value: 'Developer',text: 'Developer' }, { key: 'uc', value: 'Client',text: 'Client'}, { key: 'qc', value: 'Admin',text: 'Admin'}, { key: 'pa', value: 'Superadmin',text: 'Super Admin'} ]
        })
        
        
    }
    componentWillUnmount(){
        this.authListener && this.authListener();
        this.checkAuthStatus = undefined;
    }

    render() {
        var {email, password, password2, showError,error,signUp,signUpName} = this.state;        
        
        return (
            <div className = 'forms'>
                    {/* <ToastContainer autoClose={2000}/> */}
                    {/* condionally renders buttons */}
                    {(this.props.authenticated)?
                    (
                        <div>
                            <Redirect to='/dashboard'/>
                            <Button  negative animated = 'fade' type='button'  onClick = {this.handleSignOut}>
                                <Button.Content visible >Log Out</Button.Content>
                                <Button.Content hidden>
                                    Sure?
                                </Button.Content>
                            </Button> 
                        </div>
                    )
                    :
                    ( <div>
                    <Form onSubmit = {this.handleSignIn}>

                        <Form.Field>
                            <label>Email</label>
                            <input type='email' placeholder='Email' value = {email} onChange = {this.handleChangeEmail} required/>     
                        </Form.Field>
                        <Form.Field>
                            <label>Password</label>
                            <input type = 'password' placeholder='Password' value = {password} required onChange = {this.handleChangePassword}
                            />
                        </Form.Field>
                        <Form.Field>
                        {(signUp) ? 
                        (
                            <div>
                        <Form.Field>
                            <label>Confirm Password</label>
                                <input type = 'password' placeholder='Password' value = {password2} required onChange = {this.handleChangePassword2}
                            />
                        </Form.Field> 
                        <Form.Field>
                        <label>User Name</label>
                        <input type='text' placeholder='User Name' value = {signUpName} required onChange = {this.handChangeUserName}/>     
                        </Form.Field>
                        <Form.Field>
                            <label>Organisation</label>
                            <Dropdown onChange={this.handleChangeOrg}placeholder='Select Organisation' fluid search selection options={this.state.orgs} />  
                        </Form.Field>           
                        <Form.Field>
                            <label>Access Level</label>
                            <Dropdown onChange={this.handleChangeRole}placeholder='Select Access Level' fluid search selection options={this.state.roles} />  
                        </Form.Field>
                        </div>
                        )
                        
                        : null
                        }

                            {/* <Checkbox label='I agree to the Terms and Conditions'value = {agreedTerms} onChange = {this.handleChangeAgree} */}
                            
                        </Form.Field>

                        <Button  animated primary type='submit' onClick = {this.handleSignIn}>
                                <Button.Content visible >Log In</Button.Content>
                                <Button.Content hidden>
                                    <Icon name='right arrow' />
                                </Button.Content>
                        </Button>
                    
                        <Divider/>
                        <p>Register for an account to use the API</p>
                        <Button  animated = 'fade' type='button' onClick = {this.handleSignUp}>
                            <Button.Content visible >Register</Button.Content>
                            <Button.Content hidden>
                            <Icon name='right arrow' />
                            </Button.Content>
                        </Button>
                        
                    </Form>
                    
                    </div>
                    )

                    }

                

                {/* condionally render error message */}
                {(showError) && <Message  size='tiny' negative >{error}</Message>}
                
                <Divider/>
                

                <Modal  size='small' closeIcon trigger={<Label as = 'a' color='red'>I forgot my credentials!</Label>}>
                    <Modal.Header>Confirm Password Reset</Modal.Header>
                    <Modal.Content>
                        <p>
                            An email will be sent to your email address linked to this account.
                            
                        </p> 
                        <Form>
                        <Form.Field>
                            <label>Please enter you associated email address.</label>
                            <input id ="resetPasswd" type='email' placeholder='Email'/>    
                        </Form.Field>
                        </Form>
                        
                        {this.state.emailSent === true ? <Label inverted>Email Sent! Please check your email for reset instructions.</Label> : null}
                    </Modal.Content>
                    <Modal.Actions>

                        <Button color='red' inverted onClick={this.sendResetEmail}>
                            <Icon name='checkmark' /> Reset
                        </Button>
                    </Modal.Actions>
                </Modal>   

            </div> 
        )
    }

}

function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Login);


// WEBPACK FOOTER //
// ./src/components/login.js